// extracted by mini-css-extract-plugin
export default {"modal":"modal--rPFKo","fullscreen":"fullscreen--_i_hi"};